import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import moment from 'moment';
import get from 'lodash/get';
import styles from '../GlucoseConcentrationTrend.pcss';
import CustomLabel from './CustomLabel';
import RemoveCustomRangeBtn from './RemoveCustomRangeBtn';
const CustomRangeLabel = ({ xScale, idx, tickValues, isReadOnly = false, updatePhiSet })=>{
    const value = tickValues[idx];
    const nextValue = get(tickValues, idx + 1);
    const valueX = xScale(value);
    const nextValueX = xScale(nextValue);
    const rangeX = Math.abs(nextValueX - valueX) - 2;
    const fromHour = moment.unix(value).utc().format('LT');
    const toHour = moment.unix(nextValue).utc().format('LT');
    const style = {
        width: rangeX
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.customRange__label, {
            [styles['customRange__label--readOnly']]: isReadOnly
        }),
        style: style,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.customRange__label__textLine,
                children: [
                    `${fromHour} - ${toHour}`,
                    /*#__PURE__*/ _jsx(RemoveCustomRangeBtn, {
                        idx: idx,
                        tickValues: tickValues,
                        isReadOnly: isReadOnly,
                        updatePhiSet: updatePhiSet
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CustomLabel, {
                idx: idx,
                isReadOnly: isReadOnly,
                updatePhiSet: updatePhiSet
            })
        ]
    }, value);
};
export default CustomRangeLabel;
